/********************  START WEB API SLUG ************* */

// Prefixed WEB URL

//Athencation
export const LOGIN = '/api/web/login';
const ADMIN = '/api/web/';

// Roles
export const LIST_ROLES = ADMIN + 'role-list';
export const CREATE_OR_UPDATE_ROLE = ADMIN + 'create-or-update-role';

// Users
export const LIST_USER = ADMIN + 'get-all-users-list';
export const GET_USER_BY_ID = ADMIN + 'get-user-by-id';
export const ADD_UPDATE_USER = ADMIN + 'add-update-user';
export const CHANGE_STATUS_USER = ADMIN + 'change-status-user';

// Inward
export const GET_INWARD_LIST = ADMIN + 'list-inward-temp';
export const APPROVE_REJECT_INWARD = ADMIN + 'approve-reject-inward';
export const IMPORT_INWARD = ADMIN + 'import-inward';

// Dashboard
export const GET_DASHBOARD = ADMIN + 'dashboard';

// Inventory
export const GET_INVENTORY_LIST = ADMIN + 'list-inventory';

// Parties
export const LIST_PARTIES = ADMIN + 'list-parties';
export const GET_PARTY_BY_ID = ADMIN + 'get-party';
export const CREATE_PARTY = ADMIN + 'create-party';
export const UPDATE_PARTY = ADMIN + 'update-party';
export const DELETE_PARTY = ADMIN + 'delete-party';

// Dispatch
export const LIST_DISPATCH = ADMIN + 'list-dispatch';
export const APPROVE_REJECT_DISPATCH = ADMIN + 'approve-reject-dispatch';
export const ROLLS_DROPDOWN = ADMIN + 'rolls-dropdown';
export const MANUAL_DISPATCH = ADMIN + 'manual-dispatch';
